import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4",
      color: "darkBlue"
    },
    tabLabel: {
      fontSize: "0.9rem"
    },
    root: {
      flexGrow: 1
    },
    inputField: {
      width: "190px",
      marginLeft: "5px"
    },
    highlightedRow: {
      border: "2px solid red"
    },

    unHighlightedRow: {}
  })
);
